export default "__VITE_ASSET__BGggCpLT__"